import { render, staticRenderFns } from "./physioCategory.vue?vue&type=template&id=60b31433&scoped=true"
import script from "./physioCategory.vue?vue&type=script&lang=js"
export * from "./physioCategory.vue?vue&type=script&lang=js"
import style0 from "./physioCategory.vue?vue&type=style&index=0&id=60b31433&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b31433",
  null
  
)

export default component.exports